import type { ReportElementType } from '@highimpact-frontend/api-types';

/** Flatten a (possibly nested) report structure into exportable leaf elements. */
export function flattenExportableElements(
  elements: ReportElementType[]
): ReportElementType[] {
  const leaves: ReportElementType[] = [];

  const walk = (nodes: ReportElementType[]) => {
    nodes.forEach((element) => {
      if (element.element_type === 'collection') {
        walk(element.elements);
        return;
      }
      leaves.push(element);
    });
  };

  walk(elements);
  return leaves;
}
